import { Link } from "react-router-dom";

export default function Cta() {
  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=wide%20stylized%20anime%20illustration%20of%20open%20storybook%20with%20floating%20comic%20characters%20and%20sparkles%2C%20warm%20coral%20orange%20and%20deep%20teal%20night%20gradient%2C%20magical%20welcoming%20reading%20mood%2C%20cinematic%20composition&width=1600&height=700&seq=home-cta-banner&orientation=landscape"
        alt="开始阅读漫画"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 via-foreground-950/55 to-foreground-950/70"></div>
      <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center px-4 py-20 text-center md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm">
          <i className="ri-play-circle-line text-secondary-300" /> 现在就开启你的漫画之旅
        </span>
        <h2 className="mt-5 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          你的下一部心头好，可能就在这里
        </h2>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-50/85 md:text-base">
          无论你喜欢甜甜的恋爱、燃到爆的热血，还是烧脑的悬疑，歪歪漫画网分类大全都能帮你找到。人气排行、新作推荐、完结作品、免费专区，一次看个够。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/rankings"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            查看人气排行
          </Link>
          <Link
            to="/free"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
          >
            进入免费专区
          </Link>
        </div>
      </div>
    </section>
  );
}